import { ThemeOptions } from '@mui/material/styles';

export const MuiBlackBoxTheme: ThemeOptions = {
  palette: {
    primary: { main: '#318afb' },
    secondary: { main: '#fff' },
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          borderBottomColor: '#E0E2E6',
          // borderTopColor: '#E0E2E6',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.54)',
          padding: 0,
          fontSize: 15,
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          fontWeight: 400,
          lineHeight: 1,
          letterSpacing: 'normal',
          '&.Mui-focused': {
            color: '#6D717A',
          },
          '&.Mui-disabled': {
            color: '#6D717A !important',
          },
        },
      },
    },
    // MuiInputLabel: {
    //   styleOverrides: {
    //     root: {
    //       display: 'block',
    //       fontSize: 15,
    //       letterSpacing: 'normal',
    //       transformOrigin: 'top left',
    //       whiteSpace: 'nowrap',
    //       overflow: 'hidden',
    //       textOverflow: 'ellipsis',
    //       maxWidth: 'calc(133% - 32px)',
    //       position: 'absolute',
    //       left: 0,
    //       top: 0,
    //       pointerEvents: 'auto',
    //       zIndex: 1,
    //     },
    //     outlined: {
    //       zIndex: 'unset',
    //       transform: 'translate(16px, 19px) scale(1)',
    //       pointerEvents: 'none',
    //     },
    //     shrink: {
    //       transform: 'translate(14px, -6px) scale(0.75)',
    //       zIndex: 1,
    //     },
    //     formControl: {
    //       top: 0,
    //       left: 0,
    //       position: 'absolute',
    //       transform: 'translate(0, 24px) scale(1)',
    //     },
    //   },
    // },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: 15,
          height: 52,
          letterSpacing: 'normal',
        },
        input: {
          display: 'flex',
          height: 'unset',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          height: 'auto',
          '&:before': {
            borderBottom: 'none',
          },
          '&:after': {
            borderBottom: 'none',
          },
          '&:focus': {
            borderBottom: 'none',
          },
          '&:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error):before': {
            borderBottom: 'none',
            background: 'transparent',
          },
          '&:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error):after': {
            borderBottom: 'none',
            background: 'transparent',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontSize: 17,
          fontWeight: 500,
        },
        select: {
          '&:focus': {
            backgroundColor: 'transparent',
            background: 'transparent',
          },
        },
        icon: {
          color: 'inherit',
          right: 10,
          top: 'calc(50% - 12px)',
        },
        iconOutlined: {
          top: 'calc(50% - 8px)',
          right: 11,
          color: 'rgba(0, 0, 0, 0.54)',
          position: 'absolute',
          pointerEvents: 'none',
          fontSize: 18,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C6CBCC',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: 1,
          },
          '&:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error):not(.MuiInputBase-adornedEnd) .MuiOutlinedInput-notchedOutline': {
            border: '1px solid',
            borderColor: '#6D717A',
          },
          '&.Mui-disabled': {
            color: '#6D717A',
            backgroundColor: '#F6F6F7',
          },
          '&.MuiInputBase-adornedEnd': {
            border: '1px solid #C6CBCC',
          },
          '&.MuiInputBase-adornedEnd fieldset': {
            border: 'none',
          },
        },
        input: {
          padding: 16,
          borderColor: 'transparent'
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 15,
          borderRadius: 4,
          fontWeight: 500,
          padding: 16,
          height: 52,
          textTransform: 'initial',
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
        contained: {
          '&:hover': {
            boxShadow: 'none',
          },
        },
        textPrimary: {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
        sizeSmall: {
          height: 32,
        },
        // The following are not valid MUI v5 keys, but left for reference.
        // Remove if not used in your codebase.
        // flatPrimary: {
        //   '&:hover': {
        //     backgroundColor: 'transparent',
        //   },
        // },
        containedPrimary: {
          fontWeight: 400,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#1261C6',
          },
          '&:active': {
            boxShadow: 'none',
            backgroundColor: '#1351A2',
          },
        },
        containedSecondary: {
          fontWeight: 400,
          boxShadow: 'none',
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          paddingLeft: '16px !important',
          paddingRight: '16px !important',
          backgroundColor: '#1351A2',
        },
        title: {
          fontSize: 17,
          color: '#fff',
        },
        action: {
          marginRight: '0px !important',
          marginLeft: 0,
          marginTop: 0,
          marginBottom: 0,
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          paddingLeft: '16px !important',
          paddingRight: '16px !important',
          fontSize: 13,
          color: '#5F6670',
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: '0 0 16px !important',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          fontSize: 15,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          lineHeight: 'normal',
          letterSpacing: 'normal',
          color: '#A4A7AD !important',
          fontSize: '15px !important',
          fontWeight: 400,
          '&:hover': {
            color: '#C6C8CC !important',
          },
          '&.Mui-selected': {
            color: '#1B2432 !important',
            fontWeight: 500,
            '&:hover': {
              color: '#1B2432 !important',
            },
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            color: '#f44336',
            marginRight: '0 !important',
            marginTop: '4px !important',
          },
          textAlign: 'right',
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          width: '100%',
          display: 'table',
          fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
          borderSpacing: 0,
          borderCollapse: 'collapse',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          height: '56px',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: '48px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '4px 24px',
          minWidth: 120,
          letterSpacing: 'normal',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#C6C8CC !important',
          '&.Mui-checked': {
            color: '#318afb !important',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: '#318afb !important',
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginTop: 'unset',
          marginBottom: 'unset',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          color: '#6D717A !important',
          fontSize: 15,
          paddingTop: 6,
          paddingBottom: 6,
          '&:hover': {
            backgroundColor: 'rgba(95, 102, 112, 0.4) !important',
          },
          '&.Mui-selected': {
            backgroundColor: 'transparent !important',
          },
        },
        button: {
          '&:hover': {
            backgroundColor: '#f6f6f7 !important',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          letterSpacing: 'normal',
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 'unset',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          border: '1px solid #DDDEE0',
          boxShadow: '0 2px 4px 0 rgba(221, 222, 224, 0.5)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          border: '0',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          border: '1px solid #DDDEE0',
          boxShadow: `0 2px 4px 0 rgba(0, 0, 0, 0.05)`,
        },
        elevation2: {
          border: '1px solid #DDDEE0',
          boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)',
        },
        elevation1: {
          boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontWeight: 500,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        deleteIcon: {
          marginTop: 0,
          marginBottom: 0,
          marginLeft: 4,
          marginRight: 0,
          width: 20,
          padding: 4,
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 62,
          overflow: 'unset',
          height: 46,
          padding: 0,
          display: 'flex',
          // alignItems: 'center',
          '& .Mui-checked + .MuiSwitch-track:before': {
            content: '"ON"',
            // left: -38,
          },
        },
        switchBase: {
          backgroundColor: 'transparent !important',
          height: 48,
          width: 32,
          padding: 0,
          '&.Mui-checked': {
            transform: 'translateX(38px)',
            color: 'green',
            '& + .MuiSwitch-track': {
              backgroundColor: '#318afb !important',
              opacity: 1,
            },
          },
          '&.Mui-disabled': {
            '& + .MuiSwitch-track': {
              opacity: '0.12 !important',
            },
          },
        },
        thumb: {
          width: 24,
          height: 24,
          backgroundColor: 'white',
          boxShadow: '0px 1px 3px rgba(0,0,0,0.2)',
        },
        track: {
          borderRadius: 35,
          top: '50%',
          left: '50%',
          width: 72,
          height: 32,
          marginTop: -15,
          marginLeft: -32,
          backgroundColor: '#6d717a',
          position: 'relative',
          opacity: 1,
          '&.Mui-checked': {
            backgroundColor: '#318afb',
            opacity: 0,
          },
          '&.Mui-disabled': {
            backgroundColor: '#e0e2e6',
            opacity: 1,
          },
          '&:before': {
            content: '"OFF"',
            color: 'white',
            position: 'relative',
            top: 7,
            right: 9,
            fontSize: 15,
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
          },
        },
        disabled: {},
      },
    },
  },
};
